import React from 'react';
import { CircularProgress, FormControlLabel } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import Dialog from '../../components/Dialog/Dialog';
import { PrimaryButton, SecondaryButton, PrimaryCheckbox } from '../../components/AtomComponents';
import useQueryReview from './useQueryReview';
import { columnDefs, gridOptions, IProps } from './queryReviewUtils';
import QueryReviewHeader from './QueryReviewHeader';
import './QueryReviewConfirmationDialog.scss';

const QueryReviewConfirmationDialog = ({
  isOpen, onClose, onApprove, reviewQueries, meta, reviewData
}: IProps) => {
  const { acknowledged, setAcknowledged, handleApprove } = useQueryReview(isOpen, onClose, onApprove);
  const { queryData, newQueriesCount } = reviewData;

  let content;
  switch (queryData === null ? 'loading' : queryData.length === 0 ? 'empty' : 'data') {
    case 'loading':
      content = <div className="px-query-review-loader-container"><CircularProgress /><h5>Fetching query details...</h5></div>;
      break;
    case 'empty':
      content = <div className="px-query-review-empty-container"><h5>No queries found for review.</h5></div>;
      break;
    case 'data':
    default:
      content = (
        <div>
          <div className="ag-theme-alpine px-query-review-grid-container">
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columnDefs}
              rowData={queryData || []}
              onFirstDataRendered={(params) => params.api.resetRowHeights()}
              getRowClass={(params: any) => {
                const rowIndex = queryData ? queryData.indexOf(params.data) : -1;
                const isNew = typeof newQueriesCount === 'number' && rowIndex !== -1 && rowIndex < newQueriesCount;
                return isNew ? 'new-query-row' : '';
              }}
            />
          </div>
          <div className="px-query-review-checkbox-container">
            <FormControlLabel
              control={<PrimaryCheckbox checked={acknowledged} onChange={(e) => setAcknowledged(e.target.checked)} name="acknowledge" />}
              label="I have reviewed and acknowledge the queries to be executed."
            />
          </div>
        </div>
      );
  }

  const actions = (
    <>
      <SecondaryButton onClick={onClose} className="px-query-review-dialog-actions">Cancel</SecondaryButton>
      <PrimaryButton onClick={handleApprove} disabled={!queryData || queryData.length === 0 || !acknowledged}>
        Approve
      </PrimaryButton>
    </>
  );

  return (
    <Dialog
      isDialogOpen={isOpen}
      closeDialog={onClose}
      title={<QueryReviewHeader meta={meta} reviewQueries={reviewQueries} reviewData={reviewData} />}
      content={content}
      actions={actions}
      maxWidth="lg"
      fullWidth
      className="px-query-review-dialog"
    />
  );
};

export default QueryReviewConfirmationDialog;
